/* unplugin-vue-components disabled */import { render } from "./ChapterPageEditor.vue?vue&type=template&id=575ac992&ts=true"
import script from "./ChapterPageEditor.vue?vue&type=script&lang=ts"
export * from "./ChapterPageEditor.vue?vue&type=script&lang=ts"

import "./ChapterPageEditor.vue?vue&type=style&index=0&id=575ac992&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__